import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/bookingsSagas";
import LoadingAnimation from "../../../../../components/loadingAnimation/loadingAnimation";

export const Dropdown = ({ title, slice: key, isStatic = false, ...rest }) => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.bookings.filters[key]);
  const selectedOptions = useSelector((state) => state.bookings.selectedFilters[key]);
  const pendingFilters = useSelector((state) => state.bookings.pendingFilters);
  const isLoading = pendingFilters.includes(key);

  const onOptionsChange = (data) => {
    dispatch(actionCreators.updateFilters({ data, key }));
  };

  const renderDropdown = (
    <MultiSelectDropdown
      placeholder="Not Available"
      options={options}
      selectedFilters={selectedOptions}
      numberDisplayed={0}
      includeFilter
      enableOnly
      includeSelectAll
      onSelectChange={onOptionsChange}
      {...rest}
    />
  );

  return (
    <div className="select-box-no-width">
      <p>{title}</p>
      {isStatic ? (
        renderDropdown
      ) : isLoading ? (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      ) : (
        renderDropdown
      )}
    </div>
  );
};
